import React from "react";

export default function VerifiedBadge({
  size = 16,
  variant = 0,
}: {
  size?: number;
  variant?: number;
}) {
  // Determine the color based on the variant
  const fillColor = variant === 1 ? "#FFD24D" : "#B0B0B0"; // Gold for verified, gray for unverified
  const tooltip = variant === 1 ? "Verified" : "Unverified";

  const svg = (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill={fillColor} // Use the dynamic color
        d="M12 2l6 3v5c0 5-3.8 9.1-6 11-2.2-1.9-6-6-6-11V5l6-3z"
      />
      <path
        fill="#fff"
        d="M10 12.2l1.8 1.8L15 10.8a.6.6 0 1 1 .85.85l-4 4a.6.6 0 0 1-.85 0l-2.5-2.5a.6.6 0 0 1 0-.85.6.6 0 0 1 .5-.1z"
      />
    </svg>
  );

  return (
    <span
      className={`verified-badge ${variant === 0 ? "unverified" : "verified"}`}
      role="img"
      aria-label={tooltip}
      title={tooltip}
      style={{ display: "inline-block", verticalAlign: "middle" }}
    >
      {svg}
    </span>
  );
}